<template>
    <main id="mainCtrl">
        <ConsultantDialog ref="consultantDialog" @updated="updateTable"/>
        <v-table id="table"
                 request-uri="users/getList"
                 pagesize="100"
                 :lazycount="true"
                 ref="table">
            <template v-slot:header>
                <v-tr>
                    <v-th name="fullname" minwidth="150">
                        ФИО
                    </v-th>
                    <v-th name="email" sort="email" minwidth="150">
                        Email
                    </v-th>
                    <v-th name="phone" sort="phone" width="120">
                        Телефон
                    </v-th>
                    <v-th name="speciality" sort="speciality" minwidth="150">
                        Специальность
                    </v-th>
                    <v-th name="balance" sort="balance" width="60" tooltip="Сумма на лицевом счете">
                        Баланс
                    </v-th>
                    <v-th name="individual" sort="is_individual_consult_on" width="60" tooltip="Индивидуальные вопросы">
                        ИВ
                    </v-th>
                    <v-th name="blocked_at" sort="blocked_at" width="60">
                        Блок
                    </v-th>
                    <v-th name="passport" width="60" tooltip="Верификация паспорта пройдена">
                        Паспорт
                    </v-th>
                    <v-th name="paymentData" width="60" tooltip="Данные для выплат подтвеждены">
                        Финансы
                    </v-th>
                </v-tr>

                <v-tr>
                    <v-th name="fullname" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="email" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="phone" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="speciality" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                ...specialityOptions
                            ]'
                        />
                    </v-th>
                    <v-th name="balance"/>
                    <v-th name="individual" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "1",
                                    text: "Да"
                                },
                                {
                                    value: "0",
                                    text: "Нет"
                                },
                            ]'
                        />
                    </v-th>
                    <v-th name="blocked_at" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "1",
                                    text: "Да"
                                },
                                {
                                    value: "0",
                                    text: "Нет"
                                },
                            ]'
                        />
                    </v-th>
                    <v-th name="passport" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "1",
                                    text: "Да"
                                },
                                {
                                    value: "0",
                                    text: "Нет"
                                },
                            ]'
                        />
                    </v-th>
                    <v-th name="paymentData" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "1",
                                    text: "Да"
                                },
                                {
                                    value: "0",
                                    text: "Нет"
                                },
                            ]'
                        />
                    </v-th>
                </v-tr>
            </template>

            <template v-slot:row="{ item, index }">
                <v-tr class="hover pointer"
                      :id="'cu-tr-' + item.id"
                      :class="{'strong': item.self}"
                      @click="(row, event) => handleRowClick(event, item, row)"
                >
                    <v-td name="fullname">
                        {{ item.fullname }}
                    </v-td>
                    <v-td name="email">
                        {{ item.email }}
                    </v-td>
                    <v-td name="phone">
                        {{ item.phone }}
                    </v-td>
                    <v-td name="speciality" :highlight="specHighlight">
                        {{ item.specialities }}
                    </v-td>
                    <v-td name="balance">
                        {{ item.balance }}
                    </v-td>
                    <v-td name="individual" align="center" highlight="*">
                        {{ item.is_individual_consult_on ? 'Да' : 'Нет' }}
                    </v-td>
                    <v-td name="blocked_at" align="center" highlight="*">
                        {{ item.blocked_at ? 'Да' : 'Нет' }}
                    </v-td>
                    <v-td name="passport" align="center" highlight="*">
                        {{ item.passport ? 'Да' : 'Нет' }}
                    </v-td>
                    <v-td name="paymentData" align="center" highlight="*">
                        {{ item.paymentData ? 'Да' : 'Нет' }}
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
import ConsultantDialog from "@dialogs/admin/consult/Consultant";

export default {
    components: {
        ConsultantDialog
    },
    props: {
        specialityOptions: {
            type: Array,
            required: true
        },
    },
    methods: {
        updateTable() {
            this.$refs.table.update();
        },
        handleRowClick(event, item, row) {
            row.startLoadingAnimation();

            this.$refs.consultantDialog.show(item.id)
                .then(() => row.stopLoadingAnimation())
                .catch(() => row.stopLoadingAnimation());
        },
    },
    computed: {
        specHighlight(item) {
            if (!this.$refs || !this.$refs.table.filter) {
                return '*';
            }
            if (this.$refs.table.filter.speciality && this.specialityOptions.length) {
                return this.specialityOptions.find(sp => {return sp.value === this.$refs.table.filter.speciality}).text
            }
            return '*';
        },
    }
}
</script>
